module.exports = __webpack_public_path__ + "img/ch-assistance.a44865fb.jpg";